var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Question',{attrs:{"isMSDCustom":"","customCompanyId":_vm.customCompanyId,"surveyInfo":_vm.surveyInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }